import { MessageCircle, ArrowRight } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE } from "@/config/siteConfig";
import { useSiteSettings, getWaNumber } from "@/lib/siteSettings";
import { Reveal } from "@/components/Reveal";

export const WhatsAppStrip = () => {
  const { site } = useSiteSettings();
  return (
    <section className="bg-white py-12 sm:py-16" data-testid="whatsapp-cta-section">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6 bg-warm border border-line rounded-xl px-7 py-7 sm:px-10">
            <div className="flex items-center gap-4">
              <span className="h-12 w-12 rounded-full bg-[#25D366]/15 flex items-center justify-center shrink-0">
                <MessageCircle size={22} className="text-[#25D366]" />
              </span>
              <div>
                <h3 className="font-display text-xl sm:text-2xl font-semibold text-navy">Prefer WhatsApp?</h3>
                <p className="text-sm text-ink-soft mt-0.5">Get quick answers about properties, visits and pricing.</p>
              </div>
            </div>
            <a
              href={waLink(DEFAULT_WA_MESSAGE, getWaNumber(site))}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-cta-button"
              className="shrink-0 bg-gold text-navy hover:bg-gold-dark hover:-translate-y-0.5 transition-all duration-300 rounded-lg px-7 py-3.5 text-[15px] font-semibold inline-flex items-center gap-2 shadow-md shadow-gold/25"
            >
              Chat on WhatsApp <ArrowRight size={16} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
